/* tslint:disable:no-any */
import { MethodMeta } from './MethodMeta';
import { ServiceMeta } from './ServiceMeta';

export function Method(name: string) {
  return (target: any, targetName: string, descriptor: PropertyDescriptor) => {
    ServiceMeta.getOrCreate(target).methods.push(
      new MethodMeta({ func: descriptor.value, name: targetName, givenName: name })
    );
  };
}
